import { DateRange } from 'react-date-range';

import { styled } from '@mui/material';

interface DataRangeStyledProps {
  fonts: string;
}
export const DataRangeStyled = styled(DateRange)<DataRangeStyledProps>`
  font-family: ${(props) => props.fonts};
  .rdrDateDisplayWrapper {
    display: none;
  }
  .rdrWeekDay {
    font-weight: 600;
  }
  .rdrDayToday {
    /* .rdrStartEdge {
      color: red !important;
      z-index: 1000;
    } */

    .rdrDayNumber {
      //color: black !important;
      span {
        /* color: black !important;
        text-decoration: underline; */
      }
    }
  }
`;
